import { render, staticRenderFns } from "./AdminImportLogs.vue?vue&type=template&id=1e2b88c8&scoped=true&"
import script from "./AdminImportLogs.vue?vue&type=script&lang=ts&"
export * from "./AdminImportLogs.vue?vue&type=script&lang=ts&"
import style0 from "./AdminImportLogs.vue?vue&type=style&index=0&id=1e2b88c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b88c8",
  null
  
)

export default component.exports